<template>
  <div class="about-page">
    <div class="gywmzhong">
      <h2 class="animate__animated animate__fadeInLeft wow">{{ $t('about.overviewTitle') }}</h2>
      <p class="animate__animated animate__fadeInLeftBig wow">/&emsp;Company&nbsp;profile</p>
      <div class="gywmrunqi">
        <div :style="{ backgroundImage: `url(${require('@/assets/images/about/01.jpg')})` }"
             class="animate__animated animate__lightSpeedInLeft wow">
        </div>
        <div>
          <p class="animate__animated animate__fadeInRightBig wow">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('about.profilePara1') }}
            <br/>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('about.profilePara2') }}
            <br/>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('about.profilePara3') }}
          </p>
        </div>
      </div>
    </div>

    <!-- 关于我们轮播图 -->
    <div class="office">
      <p class="animate__animated animate__fadeInTopLeft wow">{{ $t('about.environmentTitle') }}</p>
      <span class="animate__animated animate__flipInY wow">Company environment</span>
    </div>
    <div class="container">
      <el-carousel height="500px">
        <el-carousel-item key="1">
          <div :style="{ backgroundImage: `url(${require('@/assets/images/about/b01.jpg')})` }"></div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <div :style="{ backgroundImage: `url(${require('@/assets/images/about/b02.jpg')})` }"></div>
        </el-carousel-item>
        <el-carousel-item key="3">
          <div :style="{ backgroundImage: `url(${require('@/assets/images/about/b03.jpg')})` }"></div>
        </el-carousel-item>
        <el-carousel-item key="4">
          <div :style="{ backgroundImage: `url(${require('@/assets/images/about/b04.jpg')})` }"></div>
        </el-carousel-item>
        <el-carousel-item key="5">
          <div :style="{ backgroundImage: `url(${require('@/assets/images/about/b05.jpg')})` }"></div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 公司介绍视频 -->
    <div class="company-video-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ $t('about.videoTitle') }}</h2>
          <p class="section-desc">{{ $t('about.videoDesc') }}</p>
        </div>
        <div class="video-container">
          <!--          <el-image-->
          <!--              v-if="!isPlaying"-->
          <!--              :src="videoThumbnail"-->
          <!--              fit="cover"-->
          <!--              class="video-thumbnail"-->
          <!--              @click="playCompanyVideo"-->
          <!--          >-->
          <!--            <div class="play-button">-->
          <!--              <i class="el-icon-video-play"></i>-->
          <!--            </div>-->
          <!--          </el-image>-->
          <!--          <video-->
          <!--              v-else-->
          <!--              ref="companyVideo"-->
          <!--              controls-->
          <!--              autoplay-->
          <!--              muted-->
          <!--              class="company-video"-->
          <!--              @ended="stopVideo"-->
          <!--          >-->
          <!--            <source :src="videoSource" type="video/mp4">-->
          <!--            您的浏览器不支持视频播放-->
          <!--          </video>-->
          <video
              ref="videoPlayer"
              controls
              autoplay
              muted
              class="company-video"
              poster="@/assets/images/logo/logo2.png"
          >
            <source src="@/assets/video/01.mp4" type="video/mp4">
            {{ $t('about.videoNotSupported') }}
          </video>
        </div>
      </div>
    </div>

    <!-- 团队介绍 -->
    <div class="team-section">
      <div class="page-container">
        <div class="section-header text-center">
          <h2 class="section-title">{{ $t('about.teamTitle') }}</h2>
          <p class="section-desc">{{ $t('about.teamDesc') }}</p>
        </div>
        <div class="team-container">
          <div class="team-member" v-for="(member, index) in teamMembers" :key="index">
            <div class="member-avatar">
              <img :src="member.avatar" :alt="member.name">
            </div>
            <div class="member-info">
              <h3 class="member-name">{{ member.name }}</h3>
              <p class="member-position">{{ member.position }}</p>
              <p class="member-description">{{ member.description }}</p>
              <div class="member-social">
<!--                <a v-for="(social, idx) in member.social" :key="idx" :href="social.link" target="_blank">-->
<!--                  <i :class="social.icon"></i>-->
<!--                </a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, nextTick, computed} from 'vue';
import {useI18n} from 'vue-i18n';

export default {
  setup() {
    const {t, locale} = useI18n();
    const videoThumbnail = ref(require('@/assets/images/about/办公环境2.jpg'));
    const videoSource = ref(require('@/assets/video/01.mp4'));
    const isPlaying = ref(false);
    const companyVideo = ref(null);

    // 核心团队成员（文案接入 i18n，切换语言时自动刷新；头像/图标等静态资源保持不变）
    const teamMembers = computed(() => [
      {
        name: t('about.member1Name'),
        position: t('about.member1Position'),
        description: t('about.member1Desc'),
        avatar: require('@/assets/images/about/p01.jpg'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: t('about.member2Name'),
        position: t('about.member2Position'),
        description: t('about.member2Desc'),
        avatar: require('@/assets/images/about/p02.png'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: t('about.member3Name'),
        position: t('about.member3Position'),
        description: t('about.member3Desc'),
        avatar: require('@/assets/images/about/p03.png'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      },
      {
        name: t('about.member4Name'),
        position: t('about.member4Position'),
        description: t('about.member4Desc'),
        avatar: require('@/assets/images/about/p04.png'),
        social: [
          {icon: 'el-icon-s-custom', link: '#'},
          {icon: 'el-icon-s-promotion', link: '#'}
        ]
      }
    ]);

    // 播放公司介绍视频
    const playCompanyVideo = () => {
      isPlaying.value = true;
      // 确保DOM更新后再操作视频元素
      nextTick(() => {
        if (companyVideo.value) {
          companyVideo.value.play();
        }
      });
    };

    // 停止视频播放
    const stopVideo = () => {
      isPlaying.value = false;
    };

    return {
      videoThumbnail,
      videoSource,
      isPlaying,
      companyVideo,
      teamMembers,
      playCompanyVideo,
      stopVideo
    };
  }
}
</script>

<style lang="scss" scoped>
.gywmzhong {
  margin: 5% 0 0 0;
  padding-bottom: 5%;
}

.gywmzhong > h2 {
  margin: 0 0 20px 15%;
  font-size: 36px;
  font-weight: 900;
}

.gywmzhong > p {
  color: rgb(134, 134, 134);
  margin: 0 0 20px 15%;
  font-family: Franklin Gothic Medium;
}

.gywmrunqi {
  width: 70%;
  margin: 0 auto;
  display: flex;
  padding-bottom: 5%;
}

.gywmrunqi > div {
  width: 100%;
}

.gywmrunqi > div:first-child {
  background-size: 100% 100%;
  height: 400px;
  filter: grayscale(30%);
}

.gywmrunqi > div:last-child > p {
  line-height: 30px;
  letter-spacing: 0.3px;
  color: rgb(134, 134, 134);
  padding: 0 50px 0 50px;
}

// 窄屏：图片与文字改为上下堆叠，避免文字被挤成窄长条
@media (max-width: 768px) {
  .gywmrunqi {
    width: 90%;
    flex-direction: column;
  }

  .gywmrunqi > div:first-child {
    height: 220px;
  }

  .gywmrunqi > div:last-child > p {
    padding: 20px 10px 0;
    line-height: 26px;
  }
}

.office {
  width: 100%;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.office > p {
  font-size: 36px;
  font-weight: 900;
  margin: 0;
}

.office > span {
  font-size: 14px;
  color: rgb(134, 134, 134);
  font-family: Franklin Gothic Medium;
}

.container {
  width: 100%;
  margin: 0 auto;
  background-color: #f5f7fa;
  padding-bottom: 5%;

  ::v-deep(.el-carousel) {
    width: 80%;
    margin: 0 auto;
  }

  ::v-deep(.el-carousel__item) div {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }
}

.company-video-section {
  padding: 80px 0;
  background-color: #fff;

  .video-container {
    max-width: 900px;
    margin: 50px auto 0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    position: relative;

    .video-thumbnail {
      width: 100%;
      height: 500px;
      position: relative;
      cursor: pointer;

      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;

        i {
          font-size: 40px;
          color: #fff;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
          transform: translate(-50%, -50%) scale(1.1);
        }
      }
    }

    .company-video {
      width: 100%;
      height: 500px;
      object-fit: cover;
    }
  }
}

.team-section {
  padding: 80px 0;
  background-color: #f5f7fa;

  .team-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-top: 50px;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }

    .team-member {
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s, box-shadow 0.3s;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      }

      .member-avatar {
        height: 250px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .member-info {
        padding: 20px;

        .member-name {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin: 0 0 5px;
        }

        .member-position {
          font-size: 14px;
          color: #409EFF;
          margin: 0 0 15px;
          font-weight: 500;
        }

        .member-description {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .member-social {
          display: flex;
          gap: 10px;

          a {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666;
            transition: all 0.3s;

            &:hover {
              background-color: #409EFF;
              color: #fff;
            }

            i {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

.section-header {
  margin-bottom: 30px;

  .section-title {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;

    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background-color: #409EFF;
    }
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    max-width: 700px;
    margin: 20px auto 0;
  }

  &.text-center {
    text-align: center;
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
</style>